import styled from "@emotion/styled";
import { IconButton, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { NavElement } from "./types";

interface Props {
  navItem: NavElement;
}

export const NavItem = ({ navItem }: Props) => {
  const location = useLocation();

  const isActive = location.pathname === navItem.path;
  return (
    <Container>
      <Tooltip
        // color="palette.black.main"
        title={navItem.name}
        placement="right"
      >
        <IconButton
          sx={{
            color: (theme) => theme.palette.grey[isActive ? 300 : 600],
            borderRadius: "5px",
            "& > svg": {
              fontSize: "1.1rem",
              "&:hover": {
                color: (theme) => theme.palette.primary.main,
              },
            },
          }}
          size="small"
          component={Link}
          to={navItem.path}
        >
          {navItem.icon}
        </IconButton>
      </Tooltip>
    </Container>
  );
};

const Container = styled.div(({ theme }: any) => ({
  color: theme.palette.grey[400],
  padding: "0.5rem",
}));
